import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import img from '../img/image.png'
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
// import { Link } from 'react-router-dom';
import { fetchProductById, fetchProduct, fetchSpecifications, fetchFirstLevelSort, fetchSecondLevelSort } from '../strapi';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Download from '@mui/icons-material/Download';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
// import TableHead from '@mui/material/TableHead';
import Markdown from 'react-markdown'
import TableContainer from '@mui/material/TableContainer';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { useParams, useNavigate } from 'react-router-dom';
import Search from '@mui/icons-material/Search';
import ProductCard from '../components/ProguctCard';
import Pagination from '@mui/material/Pagination';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useLocation } from 'react-router-dom';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Paper sx={{ m: 2, height: '100%' }}> <Box sx={{ p: 3 }}>{children}</Box></Paper>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function ProductPage({ locale }) {
    const { id } = useParams();
    const API_URL = process.env.REACT_APP_STRAPI_URL;
    const [product, setProduct] = useState({});
    // const [specificationId, setSpecificationId] = useState('');
    const [productList, setProductList] = useState([]);
    let paging = locale == 'ru' ? 'Показать на странице:' : 'Show on page:';
    let all = locale == 'ru' ? 'Все' : 'All';
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [pageCount, setPageCount] = useState(0);
    const [count, setCount] = useState(0);
    const [specifications, setSpecifications] = useState({});
    const [valueTab, setValueTab] = useState(0);
    const [listOpen, setListOpen] = useState(true);
    const [firstLevel, setFirstLevel] = useState([]);
    const [secondLevel, setSecondLevel] = useState([]);
    const [imgSrc, setImgSrc] = useState(img);
    const navigate = useNavigate();
    const [sort, setSort] = useState('');
    const [sortSecond, setSortSecond] = useState('');
    // const [value, setValue] = useState(-1);
    const [searching, setSearching] = useState('');
    let search = locale === 'ru' ? 'Поиск' : 'Search';

    const download = locale === 'ru' ? 'Скачать' : 'Download';
    const close = locale === 'ru' ? 'скрыть' : 'hide';
    const open = locale === 'ru' ? 'открыть' : 'open';
    const main = locale === 'ru' ? 'Продукция' : 'Products';
    const tabs = locale === 'ru' ? ['Описание', 'Тех. характеристики', 'Документация'] : ['Description', 'Tech. specifications', 'Documentation'];

    const updateSearching = (e) => {
        setSearching(e.target.value);
        fetchProduct(locale, sort, sortSecond, page, pageSize, e.target.value)
            .then(data => {
                setProductList(data.data);
                setPageCount(data.meta.pagination.pageCount);
                setCount(data.meta.pagination.total);
            })
            .catch(err => {
            });
    }
    // const updateSorting = (id) => {
    //     setSort(id);
    //     fetchProduct(locale, sort, '' , page, pageSize, id)
    //         .then(data => {
    //             setProductList(data.data);
    //             setPageCount(data.meta.pagination.pageCount);
    //             setCount(data.meta.pagination.total);
    //         })
    //         .catch(err => {
    //         });
    // }
    const changePage = (event, value) => {
        setPage(value);
        fetchProduct(locale, sort, sortSecond, value, pageSize, searching)
            .then(data => {
                setProductList(data.data);
                setPageCount(data.meta.pagination.pageCount);
                setCount(data.meta.pagination.total);
            })
            .catch(err => {
            });
    };




useEffect(() => {
    if (!window.location.hash) {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
   
}, []);

    useEffect(() => {
        const element = document.getElementById("top");
        element.scrollIntoView({ behavior: "instant", block: "start" });
        setExpandedItems([])
        if (!id ) return; 
        if (id !== "0"){
        // Check if id matches any first level sort documentId
        fetchProductById(id, locale)
            .then(data => {
                setProduct(data);
                // Save to localStorage
                // localStorage.setItem(`product_${id}_${locale}`, JSON.stringify(data));
                if (data.specification && data.specification.documentId) {
                    fetchSpecifications(data.specification.documentId, locale)
                        .then(specs => setSpecifications(specs))
                        .catch(() => setSpecifications({}));
                } else {
                    setSpecifications({});
                }
            })
            .catch(() => {
                setProduct({});
                setSpecifications({});
            }); 
        }
        const firstLevelMatch = firstLevel && firstLevel.find(item => item.documentId === id);
        if (firstLevelMatch) {
            // We want to open this level of the tree and its children (lower/second level nodes)
            // Find all second-level nodes under the current first level id
            const lowerIds = secondLevel
                ? secondLevel.filter(item => item.first_level_sort?.documentId === id).map(item => item.documentId)
                : [];
            setExpandedItems([id, ...lowerIds]);
        }
        fetchProduct(locale)
            .then(data => {
                setProductList(data.data);
            })
            .catch(() => {
                setProductList([]);
            });
        fetchFirstLevelSort(locale)
            .then(data => {
                setFirstLevel(data);
                // console.log(data);
            })
            .catch(() => {
                setFirstLevel([]);
            });
        fetchSecondLevelSort(locale)
            .then(data => {
                setSecondLevel(data);
                // console.log(data);
            })
            .catch(() => {
                setSecondLevel([]);
            });
    }, [id, locale]);

    const onButtonClick = (url, name) => {
        const link = document.createElement("a");
        link.href = url;
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    
    const onTreeClick = (id) => {
        // Navigate to the product page using React Router
        navigate(`/products/${id}`);
    };

    const handleChange = (event, newValue) => {
        setValueTab(newValue);
    };
    const getExpendedItems = () => {
        let expanded = [];
        const cachedExpanded = localStorage.getItem(`expanded_${id}_${locale}`);
        if (cachedExpanded) {
            try {
                expanded = JSON.parse(cachedExpanded) || [];
            } catch (e) {
                expanded = [];
            }
        }

        if (searching && searching.length > 0) {
            firstLevel.forEach(item => {
                if (item?.documentId && !expanded.includes(item.documentId)) {
                    expanded.push(item.documentId);
                }
            });
            secondLevel.forEach(item => {
                if (item?.documentId && !expanded.includes(item.documentId)) {
                    expanded.push(item.documentId);
                }
            });
            productList?.forEach(item => {
                if (item?.documentId && !expanded.includes(item.documentId)) {
                    expanded.push(item.documentId);
                }
            });
        } else {
            if (product?.first_level_sort?.documentId && !expanded.includes(product.first_level_sort.documentId)) {
                expanded.push(product.first_level_sort.documentId);
            }
            if (product?.second_level_sort?.documentId && !expanded.includes(product.second_level_sort.documentId)) {
                expanded.push(product.second_level_sort.documentId);
            }
            if (product?.documentId && !expanded.includes(product.documentId)) {
                expanded.push(product.documentId);
            }
        }

        return expanded;
    }

    const [expandedItems, setExpandedItems] = useState(getExpendedItems());
    const handleExpandedItemsChange = (event, itemIds) => {
        setExpandedItems(itemIds);
    };

    useEffect(() => {
        setExpandedItems(getExpendedItems());
        // eslint-disable-next-line
    }, [product, searching]);
    useEffect(() => {
        localStorage.setItem(`expanded_${id}_${locale}`, JSON.stringify(expandedItems));

    }, [expandedItems, id, locale]);

    // Load expandedItems from localStorage on mount
    useEffect(() => {
        const cachedExpanded = localStorage.getItem(`expanded_${id}_${locale}`);
        if (cachedExpanded) {
            setExpandedItems(JSON.parse(cachedExpanded));
        } else {
            setExpandedItems(getExpendedItems());
        }
        // eslint-disable-next-line
    }, [id, locale]);

    const catalogView = () => {
        if (productList.length > 0) {
            return (
                <Grid container sx={{ justifyContent: { xs: 'center', md: 'start' } }}>
                    {productList.map((item, index) => (<Grid key={index}>
                        <ProductCard
                            id={item?.documentId}
                            title={item?.nameShort}
                            text={item.description_short}
                            img={item.image !== null ? item.image.url : ''}
                            setProductId={() => onTreeClick(item.documentId)}
                            locale={locale}
                        />
                    </Grid>))}

                </Grid>
            )
        } else {
            return (
                <Typography sx={{ fontSize: 20, fontWeight: 'bold', m: 5 }} component="div">
                    {locale == 'ru' ? 'Ничего не найдено' : 'Nothing found'}
                </Typography>
            )
        }
    }
    // const firstLevelSet = () => {
    //     fetchFirstLevelSort(locale).then(data => {
    //         console.log('first level: ' + {data});
    //         return data;
    //     }).catch(() => {
    //         return [];
    //     });
    // }
    return (
        <div >
            <Container id="top">
                <Typography className='titleOfPage' component="div" sx={{ mt: { xs: '', lg: '30px' }, pt: { xs: '80px', xl: '30px' }, mb: '30px' }}>
                    {locale === "ru" ? "Каталог продукции" : "Product catalog"}
                </Typography>

                <Button className={!listOpen ? '' : 'novisible'} onClick={() => setListOpen(!listOpen)}>{listOpen ? close : open}</Button>

                <Box sx={{ height: '100%' }}>
                    <Grid container >
                        <Grid size={{ xs: 12, md: 4 }} sx={{ mb: '30px' }} className={listOpen ? '' : 'novisible'} >
                            <Button sx={{ pt: 2 }} onClick={() => setListOpen(!listOpen)}>{listOpen ? close : open}</Button>
                            <Stack sx={{ alignItems: 'center', mr: 2, p: 2 }}>
                                <Paper variant='outlined' sx={{ bgcolor: '#ffffff', width: '100%', borderRadius: '70px', p: 1, borderColor: '', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <input className='my_input' placeholder={search} onChange={updateSearching} label={search} style={{ width: '100%', border: 'none', outline: 'none', background: 'transparent' }} />
                                    <Search sx={{ bgcolor: '#2D5B96', borderRadius: '45px', alignItems: 'center', justifyContent: 'center', p: 1, color: '#ffffff' }}></Search>
                                </Paper>
                            </Stack>
                            <Paper sx={{ mr: 2, p: 2 }} className={listOpen ? '' : 'novisible'}>
                                {/* Only render the tree if there are non-empty firstLevel, secondLevel, and productList */}
                                {searching && productList && productList.length === 0 && (
                                    <Typography color="gray" sx={{ p: 2 }}>
                                        {locale === 'ru' ? 'Ничего не найдено по вашему запросу' : 'No results found for your search'}
                                    </Typography>
                                )}
                                {productList && productList.length > 0 && secondLevel.length > 0 && firstLevel.length > 0 &&
                                    <SimpleTreeView color='#1e1650' expandedItems={expandedItems} selectedItems={[id]} onExpandedItemsChange={handleExpandedItemsChange}>
                                        {firstLevel
                                            .filter(first =>
                                                secondLevel.some(second => second.first_level_sort?.documentId === first.documentId &&
                                                    productList.some(prod =>
                                                        prod.first_level_sort?.documentId === first.documentId &&
                                                        prod.second_level_sort?.documentId === second.documentId
                                                    )
                                                )
                                            )
                                            .map((first, index) => (
                                                <TreeItem
                                                    key={index}
                                                    itemId={first.documentId}
                                                    // onClick={()=>updateSorting(first.documentId)}
                                                    label={
                                                        <span style={{ fontWeight: 'bold', fontSize: '1.3rem', lineHeight: '1.2rem' }}>
                                                            {first.title}
                                                        </span>
                                                    }
                                                >
                                                    {secondLevel
                                                        .filter(second =>
                                                            second.first_level_sort?.documentId === first.documentId &&
                                                            productList.some(prod =>
                                                                prod.first_level_sort?.documentId === first.documentId &&
                                                                prod.second_level_sort?.documentId === second.documentId
                                                            )
                                                        )
                                                        .map((second, index) => (
                                                            <TreeItem
                                                                key={index}
                                                                itemId={second.documentId}
                                                                // onClick={(e)=>updateSorting(e)}
                                                                label={
                                                                    <span style={{ fontSize: '1.1rem', lineHeight: '1.2rem' }}>
                                                                        {second.title}
                                                                    </span>
                                                                }
                                                            >
                                                                {productList
                                                                    .filter(prod =>
                                                                        prod.first_level_sort?.documentId === first.documentId &&
                                                                        prod.second_level_sort?.documentId === second.documentId
                                                                    )
                                                                    .map((prod, index) => {
                                                                        // Check if searching is not empty and prod.nameShort contains searching (case-insensitive)
                                                                        const isMatch = searching && prod.nameShort && prod.nameShort.toLowerCase().includes(searching.toLowerCase());
                                                                        return (
                                                                            <TreeItem
                                                                                key={index}
                                                                                itemId={prod.documentId}
                                                                                onClick={() => onTreeClick(prod.documentId)}
                                                                                label={prod.nameShort}
                                                                                sx={isMatch ? { bgcolor: '#E1EEFF', cursor: 'pointer', color: '#2D5B96' } : { cursor: 'pointer', color: '#2D5B96' }}
                                                                            />
                                                                        );
                                                                    })}
                                                            </TreeItem>
                                                        ))}
                                                </TreeItem>
                                            ))}
                                    </SimpleTreeView>
                                }
                                {/* {productList && secondLevel.length > 0 && firstLevel.length > 0 &&
                                    <SimpleTreeView color='#1e1650' expandedItems={expandedItems} selectedItems={[id]} onExpandedItemsChange={handleExpandedItemsChange}>
                                        {firstLevel.map((first, index) => (
                                            <TreeItem
                                                key={index}
                                                itemId={first.documentId}
                                                label={
                                                    <span style={{ fontWeight: 'bold', fontSize: '1.3rem', lineHeight: '1.2rem'}}>
                                                        {first.title}
                                                    </span>
                                                }
                                                
                                            >
                                                {secondLevel
                                                    .filter((second) => second.first_level_sort?.documentId === first.documentId)
                                                    .map((second, index) => (
                                                        <TreeItem
                                                            key={index}
                                                            itemId={second.documentId}
                                                            label={
                                                            <span style={{fontSize: '1.1rem', lineHeight: '1.2rem' }}>
                                                            {second.title}
                                                        </span>}
                                                            sx={{}}
                                                        >
                                                            {productList
                                                                .filter((prod) => prod.first_level_sort?.documentId === first.documentId && prod.second_level_sort?.documentId === second.documentId)
                                                                .map((prod, index) => {
                                                                    // Check if searching is not empty and prod.nameShort contains searching (case-insensitive)
                                                                    const isMatch = searching && prod.nameShort && prod.nameShort.toLowerCase().includes(searching.toLowerCase());
                                                                    return (
                                                                        <TreeItem
                                                                            key={index}
                                                                            itemId={prod.documentId}
                                                                            onClick={() => onTreeClick(prod.documentId)}
                                                                            label={prod.nameShort}
                                                                        
                                                                            sx={isMatch ? { bgcolor: '#E1EEFF', cursor: 'pointer', color: '#2D5B96' } : { cursor: 'pointer', color: '#2D5B96' }}
                                                                        />
                                                                    );
                                                                })}
                                                        </TreeItem>
                                                    ))}
                                            </TreeItem>
                                        ))}
                                    </SimpleTreeView>
                                } */}
                            </Paper>

                        </Grid>
                        {(id === "0" || firstLevel.find(item => item.documentId === id)) && (
                            <Grid size={listOpen ? { xs: 12, md: 8 } : { xs: 12, md: 12 }} >
                                {/* <Typography
                                    variant="subtitle1"
                                    align="center"
                                    sx={{
                                        fontWeight: 500,
                                        color: '#2D5B96',
                                        fontSize: { xs: '16px', md: '20px' },
                                        letterSpacing: 0.5,
                                    }}
                                >
                                    {locale == "ru" ? "Выберите продукт из списка" : "Select product from the list"}
                                </Typography> */}
                                {catalogView()}
                                <Stack direction='row' spacing={2} sx={{ mt: 3, mb: 5, justifyContent: 'center', alignItems: 'center' }}>
                                    <Select
                                        value={pageSize}
                                        label={paging}
                                        onChange={(event) => setPageSize(event.target.value)}
                                    >
                                        <MenuItem value={10}>10</MenuItem>
                                        <MenuItem value={20}>20</MenuItem>
                                        <MenuItem value={30}>30</MenuItem>
                                        <MenuItem value={count}>{all}</MenuItem>
                                    </Select>
                                    <Pagination onChange={changePage} count={pageCount} size="large" className='pagination' sx={{ color: "#5281B5", justifyContent: 'center' }} color="primary" />
                                </Stack>

                            </Grid>
                        )}
                        {id !== "0" && !firstLevel.find(item => item.documentId === id) && (
                            <Grid size={listOpen ? { xs: 12, md: 8 } : { xs: 12, md: 12 }}>
                                <Breadcrumbs sx={{ p: 2 }}>
                                    <Typography
                                        variant={"h5"}
                                        className='breadcrumbs'
                                        onClick={() => {
                                            if (product.first_level_sort?.title) {
                                                setExpandedItems([]);
                                            }
                                            onTreeClick("0")
                                        }}
                                    >
                                        {main}
                                    </Typography>
                                    <Typography
                                        variant={"h5"}
                                        className='breadcrumbs'
                                        onClick={() => {
                                            if (product.first_level_sort?.title) {
                                                setExpandedItems([product.first_level_sort.documentId]);
                                            }
                                        }}
                                    >
                                        {product.first_level_sort?.title || ''}
                                    </Typography>
                                    <Typography
                                        variant={"h5"}
                                        className='breadcrumbs'
                                        onClick={() => {
                                            if (product.first_level_sort?.title) {
                                                setExpandedItems([product.first_level_sort.documentId, product.second_level_sort.documentId]);
                                            }
                                        }}
                                    >
                                        {product.second_level_sort?.title || ''}
                                    </Typography>
                                    <Typography
                                        variant={"h5"}
                                        className='breadcrumbs'
                                        onClick={() => {
                                            if (product.first_level_sort?.title) {
                                                setExpandedItems([product.first_level_sort.documentId, product.second_level_sort.documentId, product.documentId]);
                                            }
                                        }}
                                    >
                                        {product.nameShort || ''}</Typography>
                                </Breadcrumbs>
                                <Paper sx={{ m: 2, p: 3 }}>
                                    <Grid container>
                                        <Grid size={{ xs: 12, md: 6 }}>
                                            <Box sx={{ pl: 3 }}>
                                                <img
                                                    style={{
                                                        maxWidth: '100%',
                                                        height: 'auto',
                                                        width: '100%',
                                                        objectFit: 'contain',
                                                        maxHeight: '300px',
                                                        minHeight: '120px',
                                                    }}
                                                    alt='product'
                                                    src={product.image != null ? API_URL + product.image.url : img}
                                                    onError={() => setImgSrc(img)}
                                                />

                                            </Box>
                                        </Grid>
                                        <Grid size={{ xs: 12, md: 6 }}>
                                            <Box sx={{ pl: 3 }}>
                                                <Typography component="div" sx={{ mt: { xs: '', md: '' }, fontSize: { xs: '24px', md: '24px', lg: '24px' } }}>
                                                    {product?.name}
                                                </Typography>
                                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                                    {product?.description_short}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Paper>

                                <Box sx={{ bgcolor: '#E1EEFF', borderRadius: '5px', p: 1, m: 2 }} >
                                    <Tabs
                                        value={valueTab}
                                        onChange={handleChange}
                                        aria-label="secondary tabs example"
                                        variant="fullWidth"
                                        sx={{
                                            [`& .MuiTab-root`]: {
                                                fontSize: { xs: '10px', sm: '16px' },
                                                minWidth: 0,
                                                px: { xs: 0.5, sm: 2 },
                                            },
                                            [`& .Mui-selected`]: {
                                                color: '#2D5B96 !important',
                                                borderBottom: '1px solid #2D5B96 !important',
                                            },
                                            [`& .MuiTabs-indicator`]: {
                                                backgroundColor: '#2D5B96',
                                            },
                                        }}
                                    >
                                        {tabs.map((tab, index) => (
                                            <Tab
                                                key={index}
                                                value={index}
                                                label={tab}
                                                sx={{
                                                    color: '#2D5B96',
                                                    fontWeight: 300,
                                                    minWidth: 0,
                                                    px: { xs: 0.5, sm: 2 },
                                                }}
                                            />
                                        ))}
                                    </Tabs>
                                </Box>
                                <CustomTabPanel key={0} value={valueTab} index={0}>
                                    <Markdown>{product.description}</Markdown>
                                </CustomTabPanel>
                                <CustomTabPanel key={1} value={valueTab} index={1} >
                                    {product.specifications && product.specifications.map((item, index) =>
                                        <TableContainer key={index} mb={3} >
                                            <Typography className='tableHeader'>{item.title}</Typography>
                                            <Table key={index} sx={{ minWidth: 300 }} aria-label="caption table">
                                                <TableBody>
                                                    {item.rows && item.rows.map((item, index) =>
                                                        <TableRow key={index}>
                                                            <TableCell component="th" scope="row">
                                                                {item.first}
                                                            </TableCell>
                                                            <TableCell align="right">{item.second}</TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                            {item.text && <Markdown>{item.text}</Markdown>}
                                        </TableContainer>
                                    )}
                                </CustomTabPanel>
                                <CustomTabPanel key={2} value={valueTab} index={2}>
                                    {product.docs != null && product.docs.map((item, index) =>
                                        <Box key={index} sx={{ border: '1px solid #2D5B96', borderRadius: '5px', p: 1, m: '10px 5px' }}>
                                            <Stack direction='row' justifyContent='space-between' alignItems='center'>
                                                <Typography fontSize='12px' ml={2}>{item.name}</Typography>
                                                <Button variant='contained' sx={{ m: '5px 2px', backgroundColor: '#5281B5', color: '#fff !important' }}
                                                    onClick={() => onButtonClick(API_URL + item.url, item.name)}>{download}

                                                    <Download m={2}></Download>
                                                </Button>
                                            </Stack>
                                        </Box>
                                    )}
                                </CustomTabPanel>
                            </Grid>
                        )}
                    </Grid>
                </Box>

            </Container>
        </div>
    );
}

export default ProductPage;
